import { FileChartLine } from "lucide-react";
import { ModelListItemFragment } from "@/apollo/types";
import { EmojiIcon } from "@/components/elements/EmojiIcon";
import classNames from "@/helpers/classNames";

import { isDraftModel, isPendingTable } from "../../utils/modelUtils";
import ModelSVGIcon from "./ModelSVGIcon";

type ModelIconProps = {
  model: Pick<
    ModelListItemFragment,
    | "emoji"
    | "materializationType"
    | "publishedQueryId"
    | "dwTable"
    | "dashboardId"
  >;
  className?: string;
};

function getEmojiCharCode(emoji?: string | null) {
  if (!emoji) return null;
  const code = parseInt(emoji, 16);
  return isNaN(code) ? null : code;
}

export const ModelIcon = ({ model, className }: ModelIconProps) => {
  const baseClasses = isPendingTable(model) ? "opacity-50" : "";
  const emojiCharCode = getEmojiCharCode(model.emoji);
  if (emojiCharCode) {
    return (
      <EmojiIcon
        symbol={emojiCharCode}
        className={classNames(baseClasses, className)}
      />
    );
  }
  if (!!model.dashboardId) {
    return (
      <FileChartLine className={classNames("size-4 shrink-0", className)} />
    );
  }
  return (
    <ModelSVGIcon
      type={model.materializationType}
      isDraft={isDraftModel(model)}
      className={classNames("size-4 shrink-0", baseClasses, className)}
    />
  );
};
